// Enums para tipos de parâmetros
export const KPIType = {
  CAC: { value: 0, label: 'CAC - Custo de Aquisição de Cliente', type: 'kpi' }
};

export const FinancialGroupType = {
  CustosFixos: { value: 0, label: 'Custos Fixos', type: 'financialGroup' },
  CustosVariaveis: { value: 1, label: 'Custos Variáveis', type: 'financialGroup' },
  DespesasFixas: { value: 2, label: 'Despesas Fixas', type: 'financialGroup' },
  DespesasVariaveis: { value: 3, label: 'Despesas Variáveis', type: 'financialGroup' },
  Investimentos: { value: 4, label: 'Investimentos', type: 'financialGroup' }
};

export const DFCType = {
  AtividadesOperacionais: { value: 0, label: 'Atividades Operacionais', type: 'dfc' },
  AtividadesInvestimentos: { value: 1, label: 'Atividades de Investimentos', type: 'dfc' },
  AtividadesFinanciamentos: { value: 2, label: 'Atividades de Financiamentos', type: 'dfc' }
};

export const DREType = {
};

// Configurações dos tipos de parâmetros
export const PARAMETER_CONFIGS = {
  dfc: {
    title: 'Configurar DFC',
    subtitle: 'Configure as categorias para o Demonstrativo de Fluxo de Caixa',
    color: '#722ed1',
    types: DFCType,
    configKey: 'dfcConfig',
    typeField: 'Type'
  },
  indicadores: {
    title: 'Configurar Indicadores',
    subtitle: 'Configure as categorias para os Indicadores Financeiros',
    color: '#13c2c2',
    types: KPIType,
    configKey: 'kpiConfig',
    typeField: 'Type'
  },
  gruposFinanceiros: {
    title: 'Configurar Grupos Financeiros',
    subtitle: 'Configure as categorias para análise por Grupos Financeiros',
    color: '#fa8c16',
    types: FinancialGroupType,
    configKey: 'financialGroupConfig',
    typeField: 'FinancialGroup'
  },
  dre: {
    title: 'Configurar Estrutura DRE',
    subtitle: 'Configure as categorias para a Estrutura DRE',
    color: '#1890ff',
    types: DREType,
    configKey: 'dreConfig',
    typeField: 'DRE'
  }
}; 